/*
 * react-intl scaffold.
 *
 * Phase 3 ships only an English string catalog. Portuguese (pt-BR) is the
 * second supported locale per plan G2; messages are stubbed empty so the
 * provider falls back to `defaultMessage` strings supplied at the call site.
 *
 * Locale resolution preference order:
 *   1. `caratuva.locale` in localStorage (manual override).
 *   2. `navigator.language` mapped to a supported locale.
 *   3. 'en' as final fallback.
 */

import en from './en.json';
import ptBR from './pt-BR.json';

export type SupportedLocale = 'en' | 'pt-BR';

const SUPPORTED: ReadonlyArray<SupportedLocale> = ['en', 'pt-BR'];

const CATALOGS: Record<SupportedLocale, Record<string, string>> = {
  en,
  'pt-BR': ptBR,
};

const STORAGE_KEY = 'caratuva.locale';

export function resolveLocale(): SupportedLocale {
  if (typeof window === 'undefined') return 'en';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && (SUPPORTED as ReadonlyArray<string>).includes(stored)) {
    return stored as SupportedLocale;
  }
  const nav = window.navigator.language;
  if (nav.toLowerCase().startsWith('pt')) return 'pt-BR';
  return 'en';
}

export function getMessagesForLocale(locale: SupportedLocale): Record<string, string> {
  return CATALOGS[locale];
}
